import {navProps, plannerProps} from './properties'

export const setProductionAutoCompleteList = (state, payload) => {
    state.autocomplete_list = payload
}  

export const setProductionWorkerWorkStatus = (state, payload) => {
    state.worker_work_status_list = payload
}  

export const setProductionProcessBatchList = (state, payload) => {
    state.process_batch_list.process_list = payload
}  

export const setProductionWorkOrderList = (state, payload) => {
    
    //state.searched = 0
    if(payload.store_query) {
        state.planner.list = {future_orders: []}
        state.planner.list.future_orders = payload.response
    } else {
        state.list = payload.response        

        if(state.list.filter(t => t.priority_order === 1).length > 0) {
            state.list = state.list.sort( (a,b) => { 
                var x = a.priority_order > b.priority_order? -1:1; 
                return x; 
            });
        }
        
    }
    
    state.nav.total = payload.total
    state.nav.page_number = payload.page_number
}

export const setProductionGroupWorkOrderList = (state, payload) => {

    state.group_work_order.list = payload.response        
    
    state.group_work_order.nav.total = payload.total
    state.group_work_order.nav.page_number = payload.page_number

}

export const setProductionWorkOrderAssignmentHistory = (state, payload) => {
    state.assignment_history = payload
}

export const updateWorkOrderAssignment_WorkStatus = (state, payload) => {
    let keyIndex = state.list.findIndex(t => t.production_work_log_id === payload.old_work_log_id)
    if(keyIndex >=0) {
        if(payload.update_finished_item) {
            if(payload.work_status === 4 || payload.work_status === 0) {
                state.list[keyIndex].action_type = 'start'
                state.list[keyIndex].work_status = 0
                state.list[keyIndex].production_work_log_id = payload.work_log_id
                state.list[keyIndex].worker_id = null
                state.list[keyIndex].worker_data = null
                if(payload.production_row === null) {
                    window.location.reload()
                }
                state.list[keyIndex].work_order_process_id = payload.production_row.work_order_process_id
                state.list[keyIndex].process_id = payload.production_row.process_id
                state.list[keyIndex].process_name = payload.production_row.process_name
                state.list[keyIndex].next_process_id = payload.production_row.next_process_id
                state.list[keyIndex].next_process_name = payload.production_row.next_process_name
                state.list[keyIndex].hidden_process = payload.production_row.hidden_process
            } else if(payload.work_status <4) {
                state.list[keyIndex].work_status = payload.work_status
            }
        } else {
            if(payload.work_status === 4) {
                state.list.splice(keyIndex, 1)
            } else {
                state.list[keyIndex].work_status = payload.work_status
            }
            
        }        
    }
}

export const unsetWorkOrderTrial = (state, payload) => {
    let keyIndex = state.list.findIndex(t => t.id === payload)
    if(keyIndex >=0) {
        state.list[keyIndex].appointment_type = 0
        state.list[keyIndex].trial_name = ''
        state.list[keyIndex].trial_type_id = 0
    }
}

export const setWorkOrderTrial = (state, payload) => {

    let keyIndex = state.list.findIndex(t => t.id === payload.production_id)
    if(keyIndex >=0) {
        state.list[keyIndex].appointment_type = 1
        state.list[keyIndex].trial_name = payload.trial_name
        state.list[keyIndex].trial_type_id = payload.trial_type_id
    }
}

export const setWorkOrderTrialApproval = (state, payload) => {
    let keyIndex = state.list.findIndex(t => t.id === payload)
    if(keyIndex >=0) {
        state.list[keyIndex].trial_approval_required = 0
    }
}

export const setProductionWorkerHistory = (state, payload) => {
    state.worker_history = payload
}

export const setReadyOrderList = (state, payload) => {
    state.ready_orders = payload
}

export const setReadyOrderList_DetailList = (state, payload) => {
    state.ready_order_detail_list = payload
}

export const mutate_SetReadyOrderList_DetailList = (state, payload) => {
    let customerIndex = state.ready_order_detail_list.findIndex(t => t.customer_id === payload.customer_id)
    if(customerIndex>=0) {
        state.ready_order_detail_list[customerIndex].appointment_date = payload.appointment_date
        state.ready_order_detail_list[customerIndex].appointment_date_changed = payload.appointment_date_changed
    }
}

export const setLoadPlannerData = (state, payload) => {
    
    if(state.planner.list === null) {
        state.planner.list = payload.list
    } else {
        state.planner.list.future_orders = payload.list.future_orders
    }
    
    state.planner.start_date = payload.start_date
    state.planner.end_date = payload.end_date
    state.planner.date_label = payload.date_label

}

export const resetProductionNavProps = state => {
    state.nav = JSON.parse(JSON.stringify(navProps))
}

export const resetProductionList = state => {
    state.list = null
    state.searched = 0
}  

export const resetProductionGroupNavProps = state => {
    state.group_work_order.nav = JSON.parse(JSON.stringify(navProps))
    state.group_work_order.nav.sort_column_name = 't5.delivery_date'
    state.group_work_order.nav.sort_direction = 1
}

export const resetProductionGroupList = state => {
    state.group_work_order.list = []
}  

export const resetProductionAutoCompleteList = state => {
    state.autocomplete_list = []
}

export const resetProductionPlanner = state => {
    state.planner = JSON.parse(JSON.stringify(plannerProps))
}

export const setProductionWorkSubProcessList = (state, payload) => {
    let finalArray = []

    const productionListIndex = state.list.findIndex(t => t.id === payload.queryPayload.production_id)
    const workLogList = payload.response
    const mainProcessId = payload.queryPayload.main_process_id
    const currentStoreId = payload.queryPayload.current_store_id
    const workOrderProcessCacheList = payload.queryPayload.work_order_process_cache_list
    const subTailoringItemId = payload.queryPayload.sub_tailoring_item_id
    const tailoringItemId = payload.queryPayload.tailoring_item_id

    const findMainProcessElement = workOrderProcessCacheList.filter(t => t.process_id === mainProcessId)
    if(findMainProcessElement.length>0) {
        const subProcessList = findMainProcessElement[0].sub_process_list

        subProcessList.filter(t => t.is_required).forEach(element => {

            const logFilter = workLogList.length>0 ? workLogList.filter(t => t.process_id === element.id) : []

            let arrayElement = {
                work_log_id: 0,
                worker_id: null,
                worker_name: '',
                work_status: 0,
                remarks: '',
                started_at: '',
                started_at_changed_time: '',
                finished_at: '',
                finished_at_changed_time: '',
                default_piece_rate: 0,
                extra_payment: 0,
                total_piece_rate: 0,
                payroll_id: 0,
                work_order_process_id: 0,
                process_id: element.id,
                process_name: element.process_name,
                current_store_id: currentStoreId,
                sub_tailoring_item_id: subTailoringItemId,
                tailoring_item_id: tailoringItemId
            }

            if(logFilter.length>0) {
                arrayElement.work_log_id = logFilter[0].id
                arrayElement.worker_id = logFilter[0].worker_id
                arrayElement.worker_name = logFilter[0].staff_name
                arrayElement.work_status = logFilter[0].work_status
                arrayElement.remarks = logFilter[0].remarks
                arrayElement.started_at = logFilter[0].started_at
                arrayElement.started_at_changed_time = logFilter[0].started_at_changed_time
                arrayElement.finished_at = logFilter[0].finished_at
                arrayElement.finished_at_changed_time = logFilter[0].finished_at_changed_time
                arrayElement.default_piece_rate = logFilter[0].default_piece_rate
                arrayElement.extra_payment = logFilter[0].extra_payment
                arrayElement.total_piece_rate = logFilter[0].total_piece_rate
                arrayElement.payroll_id = logFilter[0].payroll_id
                arrayElement.work_order_process_id = logFilter[0].work_order_process_id
            }

            finalArray.push(arrayElement)

        })
        console.log(productionListIndex)
        state.list[productionListIndex].sub_process_list = finalArray
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/production/mutations.js